(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0217"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0217"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4tUT1", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $3435ff53ab168142$export$6503ec6e8aabbaf; }, function (v) { return $3435ff53ab168142$export$6503ec6e8aabbaf = v; });
var $3435ff53ab168142$export$6503ec6e8aabbaf;
var $3435ff53ab168142$export$f7ad0328861e2f03;
"use strict";
var $3435ff53ab168142$var$mapping = new Map();
function $3435ff53ab168142$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$3435ff53ab168142$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $3435ff53ab168142$var$resolve(id) {
    var resolved = $3435ff53ab168142$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$3435ff53ab168142$export$6503ec6e8aabbaf = $3435ff53ab168142$var$register;
$3435ff53ab168142$export$f7ad0328861e2f03 = $3435ff53ab168142$var$resolve;

});

parcelRegister("lanWR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $f68d1bd12cbe4c71$export$bdfd709ae4826697; }, function (v) { return $f68d1bd12cbe4c71$export$bdfd709ae4826697 = v; });
var $f68d1bd12cbe4c71$export$bdfd709ae4826697;
var $f68d1bd12cbe4c71$export$c9e73fbda7da57b6;
var $f68d1bd12cbe4c71$export$5a759dc7a1cfb72a;
"use strict";
var $f68d1bd12cbe4c71$var$bundleURL = {};
function $f68d1bd12cbe4c71$var$getBundleURLCached(id) {
    var value = $f68d1bd12cbe4c71$var$bundleURL[id];
    if (!value) {
        value = $f68d1bd12cbe4c71$var$getBundleURL();
        $f68d1bd12cbe4c71$var$bundleURL[id] = value;
    }
    return value;
}
function $f68d1bd12cbe4c71$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $f68d1bd12cbe4c71$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $f68d1bd12cbe4c71$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $f68d1bd12cbe4c71$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$f68d1bd12cbe4c71$export$bdfd709ae4826697 = $f68d1bd12cbe4c71$var$getBundleURLCached;
$f68d1bd12cbe4c71$export$c9e73fbda7da57b6 = $f68d1bd12cbe4c71$var$getBaseURL;
$f68d1bd12cbe4c71$export$5a759dc7a1cfb72a = $f68d1bd12cbe4c71$var$getOrigin;

});

var $4621c419129be690$exports = {};


(parcelRequire("4tUT1")).register((parcelRequire("lanWR")).getBundleURL("8jssz"), JSON.parse('["8jssz","index.c0b1a077.js","dndhY","uwu_plain.89c01b2b.svg","kaAaQ","index.812f2344.css"]'));

})();
//# sourceMappingURL=index.runtime.1fb84831.js.map
